/**
 * @generated SignedSource<<f45d56ad651b2b42b5369987d6274477>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatActionBank$data = {
  readonly bankAccount: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "ChatActionBank";
};
export type ChatActionBank$key = {
  readonly " $data"?: ChatActionBank$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatActionBank">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatActionBank",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BankAccount",
      "kind": "LinkedField",
      "name": "bankAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "2c00875c87b5126858b5ad5732642a3c";

export default node;
